import React from "react";
import clsx from "clsx";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (props, ref) => {
    return (
      <textarea
        ref={ref}
        {...props}
        className={clsx(
          "border border-gray-300 rounded-md p-2 w-full resize-y",
          props.className
        )}
      />
    );
  }
);

Textarea.displayName = "Textarea";

